var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_349_113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 21,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_349_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.808 11.728C10.5333 11.9413 11.088 12.3467 11.472 12.944C11.8987 13.4987 12.112 14.1813 12.112 14.992C12.112 16.016 11.792 16.848 11.152 17.488C10.512 18.128 9.72267 18.448 8.784 18.448C7.76 18.448 6.928 18.128 6.288 17.488C5.69067 16.8053 5.392 15.9733 5.392 14.992C5.392 14.48 5.43467 13.9893 5.52 13.52C5.648 13.008 5.88267 12.2827 6.224 11.344L8.912 2.512H11.984L9.808 11.728ZM20.688 11.728C21.4133 11.9413 21.968 12.3467 22.352 12.944C22.7787 13.4987 22.992 14.1813 22.992 14.992C22.992 16.016 22.672 16.848 22.032 17.488C21.392 18.128 20.6027 18.448 19.664 18.448C18.64 18.448 17.808 18.128 17.168 17.488C16.5707 16.8053 16.272 15.9733 16.272 14.992C16.272 14.48 16.3147 13.9893 16.4 13.52C16.528 13.008 16.7627 12.2827 17.104 11.344L19.792 2.512H22.864L20.688 11.728Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuotes);
export default __webpack_public_path__ + "static/media/ic-quotes.09bfca9e467848574bda8e99595d756a.svg";
export { ForwardRef as ReactComponent };